import baseAPI from '@/http'

const router = 'api/territorios-iniciativa'

export const territorioIniciativaAPI = {
  create: (city) => baseAPI.post(router, city),
  update: (city) => baseAPI.put(router, city),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
  obterPorEixo: (territorioEixoId)=> baseAPI.get(`${router}/obter-territorio-por-eixo/${territorioEixoId}`), 
}
